import { render, staticRenderFns } from "./add-group.vue?vue&type=template&id=98f9a01a&"
import script from "./add-group.vue?vue&type=script&lang=js&"
export * from "./add-group.vue?vue&type=script&lang=js&"
import style0 from "./add-group.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./add-group.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./add-group.vue?vue&type=style&index=2&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports